import React, { FC, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Trans, useTranslation } from 'react-i18next';
import SignUpForm from 'components/Forms/SignUpForm';
import ResendActivationMail from 'components/Forms/SignUpForm/ResendActivationMail';
import { SignUpInputs } from 'components/Forms/SignUpForm/useSignUpRequest';
import Session from 'components/Session';
import { SParagraph } from './styles';

/**
 * Le serveur répond de la même façon que l'adresse soit déjà connue ou non, pour ne pas révéler qui
 * est client : l'écran doit rester vrai dans les deux cas.
 */
const CheckYourMailbox: FC<{ inputs: SignUpInputs }> = ({ inputs }) => {
    const { t } = useTranslation();

    return (
        <>
            <SParagraph>
                <Trans
                    components={{ strong: <strong /> }}
                    i18nKey="page.sign-up.confirmation.sent"
                    values={{ email: inputs.email }}
                />
            </SParagraph>
            <SParagraph>{t('page.sign-up.confirmation.not-received')}</SParagraph>
            <ResendActivationMail inputs={inputs} />
        </>
    );
};

const SignUpPage: FC = () => {
    const { t } = useTranslation();
    const [signedUp, setSignedUp] = useState<SignUpInputs | null>(null);

    return (
        <Session access="login" title={signedUp ? t('page.sign-up.confirmation.title') : t('page.sign-up.title')}>
            <Helmet>
                <title>{t('page.sign-up.meta-title')}</title>
            </Helmet>
            {signedUp ? <CheckYourMailbox inputs={signedUp} /> : <SignUpForm onSignedUp={setSignedUp} />}
        </Session>
    );
};

export default SignUpPage;
